/**
 * Master Account (S1, PAD-31765): the single seam for "may this user act on
 * this team?".
 *
 * The auth payload carries only the ACTIVE team (`user.clientId`) — a team
 * switch re-mints it server-side (POST /platform/switch-team). So today this
 * reduces to the active-team check, byte-identical to the historical
 * single-client guard (`user.clientId != clientId`) it replaces (the old
 * loose-equality coercion is preserved via String()).
 *
 * When S5 (the team switcher) exposes the accessible-team set on the payload,
 * extend the `accessibleTeamIds` branch — both campaign-data HOCs become
 * membership-aware without changing their call sites.
 *
 * @param {{ clientId?: number|string, accessibleTeamIds?: Array }} user
 *   The value returned by `authorization.getUser()`.
 * @param {number|string} teamId The team (clientId) from the route params.
 * @returns {boolean}
 */
export const canAccessTeam = (user, teamId) => {
  if (teamId === undefined || teamId === null || teamId === "") return false;

  const activeTeamId = user && user.clientId;
  if (activeTeamId !== undefined && String(activeTeamId) === String(teamId)) {
    return true;
  }

  // Seam for S5: the membership set is not yet present on the auth payload.
  const accessible = (user && user.accessibleTeamIds) || [];
  return accessible.map(String).includes(String(teamId));
};
